var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 124,
    viewBox: "0 0 123 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receipt 1",
    clipPath: "url(#clip0_2298_103200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.8328 54.0992L46.0507 44.1583C46.0507 44.1583 40.7513 28.1395 33.8888 31.7053C27.0263 35.2711 27.8337 41.461 28.0691 46.5069C28.3046 51.553 28.8328 54.0992 28.8328 54.0992Z",
    fill: "#C2CDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M104.638 90.8096C104.55 90.7707 104.464 90.7305 104.379 90.682C99.8129 88.0457 96.9764 83.1326 96.9764 77.86V17.6952C96.9764 11.0784 93.4166 4.91256 87.6861 1.60358C85.1372 0.132141 82.0942 0.132141 79.546 1.60358C79.1587 1.82723 78.7984 2.08044 78.4604 2.35479L28.832 31.0078C42.9845 31.0078 46.1669 45.4307 46.1669 45.4307C46.1669 45.4307 46.1669 106.981 46.1669 112.632C46.1669 118.284 58.5029 121.366 58.5029 121.366L104.638 94.73V90.8096Z",
    fill: "#EFF2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M110.288 71.3301C109.994 71.3301 109.719 71.4033 109.47 71.5235L109.47 71.5184L109.323 71.6035C109.289 71.6239 109.253 71.6402 109.22 71.6628L59.693 100.258L59.2949 122.625L108.948 93.9513C110.969 92.7842 112.176 90.6942 112.176 88.3603V73.2178C112.176 72.1752 111.331 71.3301 110.288 71.3301Z",
    fill: "#C2CDDD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M56.0676 123.5C54.9586 123.5 53.8504 123.208 52.8395 122.625C47.109 119.316 43.5492 113.15 43.5492 106.533V46.3686C43.5492 41.0959 40.7127 36.1829 36.1464 33.5466C34.7802 32.7576 33.148 32.7576 31.7818 33.5466C30.4151 34.3355 29.5993 35.7488 29.5993 37.3269V52.582C29.5993 53.6246 28.7544 54.4695 27.7117 54.4695C26.6691 54.4695 25.8242 53.6244 25.8242 52.582V37.3269C25.8242 34.384 27.3456 31.7487 29.8943 30.2772C32.4429 28.806 35.4855 28.806 38.0341 30.2772C43.7647 33.5857 47.3245 39.7516 47.3245 46.3686V106.533C47.3245 111.806 50.1609 116.719 54.7273 119.355C55.5664 119.84 56.5687 119.84 57.4078 119.355C58.2472 118.871 58.7483 118.003 58.7483 117.034V101.891C58.7483 100.849 59.5932 100.004 60.6359 100.004C61.6785 100.004 62.5234 100.849 62.5234 101.891V117.034C62.5234 119.368 61.3167 121.458 59.2954 122.625C58.2847 123.208 57.1762 123.5 56.0676 123.5Z",
    fill: "#667790"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M87.9217 24.5653L57.2685 42.2336C55.7008 43.1388 54.4297 45.5671 54.4297 47.6576C54.4297 49.7481 55.7008 50.7088 57.2685 49.8036L87.9217 32.1353C89.4895 31.2301 90.7606 28.8016 90.7606 26.7113C90.7603 24.6208 89.4895 23.6601 87.9217 24.5653Z",
    fill: "#667790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M87.9222 36.3036L79.0693 41.3848C77.5016 42.29 76.2305 44.7183 76.2305 46.8088C76.2305 48.8993 77.5016 49.86 79.0693 48.955L87.9222 43.8738C89.49 42.9686 90.761 40.5404 90.761 38.4498C90.7608 36.3591 89.49 35.3984 87.9222 36.3036Z",
    fill: "#667790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M87.9217 56.0262L57.2685 73.6945C55.7008 74.5997 54.4297 77.028 54.4297 79.1185C54.4297 81.209 55.7008 82.1697 57.2685 81.2648L87.9217 63.5965C89.4895 62.6913 90.7606 60.2628 90.7606 58.1725C90.7603 56.0817 89.4895 55.121 87.9217 56.0262Z",
    fill: "#667790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M87.9222 67.7645L79.0693 72.8457C77.5016 73.7509 76.2305 76.1792 76.2305 78.2697C76.2305 80.3603 77.5016 81.3209 79.0693 80.4157L87.9222 75.3345C89.49 74.4293 90.761 72.0011 90.761 69.9105C90.7608 67.82 89.49 66.8593 87.9222 67.7645Z",
    fill: "#667790"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2298_103200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.948cd45dae9752af2c34f868d37f9e27.svg";
export { ForwardRef as ReactComponent };